/**
 * Validate product size selection
 */

import { useProductPageStore } from "../stores/productPageStore";

export const validateRegularSizeSelection = (productPageStore: ReturnType<typeof useProductPageStore>) => {
  if (!productPageStore.sizeSelected) {
    productPageStore.displaySizeNotSelectedError = true;
    return false;
  }
  productPageStore.displaySizeNotSelectedError = false;
  return true;
};

export const validatePantsSizeSelection = (productPageStore: ReturnType<typeof useProductPageStore>) => {
  if (productPageStore.widthSelected && productPageStore.lengthSelected) {
    productPageStore.displayWidthNotSelectedError = false;
    productPageStore.displayLengthNotSelectedError = false;
    return true;
  }

  if (!productPageStore.widthSelected) {
    productPageStore.displayWidthNotSelectedError = true;
  }
  if (!productPageStore.lengthSelected) {
    productPageStore.displayLengthNotSelectedError = true;
  }
  return false;
};

export const validateSuitSizeSelection = (productPageStore: ReturnType<typeof useProductPageStore>) => {
  const { sizeSelected, widthSelected, lengthSelected } = productPageStore;

  productPageStore.displaySizeNotSelectedError = !sizeSelected;
  productPageStore.displayWidthNotSelectedError = !widthSelected;
  productPageStore.displayLengthNotSelectedError = !lengthSelected;

  return sizeSelected && widthSelected && lengthSelected;
};

export const validateSizeSelection = (sizePickerType: string, productPageStore: ReturnType<typeof useProductPageStore>) => {
  switch (sizePickerType) {
    case "suit":
      return validateSuitSizeSelection(productPageStore);
    case "pants":
      return validatePantsSizeSelection(productPageStore);
    case "regular":
      return validateRegularSizeSelection(productPageStore);
    default:
      return false;
  }
};
